import gql from 'graphql-tag';

export const EditorStartHeartbeatMutation = gql`
	mutation EditorStartHeartbeatMutation(
		$contentId: ID!
		$contentType: String!
		$collabService: String!
		$heartbeatUserType: ExperimentalHeartbeatUserType
	) @experimental {
		experimentalEditorStartHeartbeat(
			contentId: $contentId
			contentType: $contentType
			collabService: $collabService
			heartbeatUserType: $heartbeatUserType
		) {
			orderedUsers {
				accountId
				heartbeatUserType
			}
			editorSessionId
			error
			message
			subtype
		}
	}
`;
